let _ = window._;
let Backbone = window.Backbone;
let $ = jQuery;

export default Backbone.View.extend({
  tagName: 'span',
  className: 'userContent__deleteFilter__item',
  template: _.template($('#userContent-selectedFilters-tpl').html()),
  events: {
    'click .js-userContent__deleteFilter': 'removeFilter'
  },

  initialize: function() {
    this.render()
  },

  render: function() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  },

  removeFilter: function(e) {
    e.preventDefault();
    window.sfscpaVent.trigger('delete-filter', this.model);
  },
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/filters/SelectedFilter.view.js